<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core';
import { DialogTitle, useForwardProps, type DialogTitleProps } from 'reka-ui';

import { cn } from '@/lib/utils';

import type { HTMLAttributes } from 'vue';

const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DialogTitle
    data-slot="dialog-title"
    v-bind="forwardedProps"
    :class="cn('text-lg leading-none font-semibold', props.class)"
  >
    <slot />
  </DialogTitle>
</template>
